module.exports = __webpack_public_path__ + "img/CRC-logo_principal.be8054b1.svg";